import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsBusZoneModel {
  id: number;
  situationType: string;
  creationDate: string;
  eventDate: string;
  status: string;
  title: string;
  markerPopupText: string;
  icon: Icon;
  location:string;
  category: string;
  subcategory: string;
  priority: string;
  postalcode: string;
  source: string;
  mediaName: string;
  situationName: string;
  observations: string;
  observationsAuthor: string;
}

export interface IPropsFilterModel {
  value: string;
  label: string;
}

export class BusZoneModel extends MarkerModelBase {
  static className = 'BusZoneModel';
  classProperties: IPropsBusZoneModel;

  constructor(props: IPropsBusZoneModel, geometry: IGeometryModel) {
    super(geometry, BusZoneModel.className);
    this.classProperties = props;
  }
};

export enum NameRunwayEnum {
  Aparcapatinetes = 'Aparcapatinetes.json',
  EstacionesPrestamobicis = 'EstacionesPrestamobicis.json',
  Paradas = 'Paradas.json',
  Rutas = 'Rutas.json',
}

export enum TypeFilterEnum {
  Line = 'Line',
  Stop = 'Stop',
}

// lineas
export const getLinesFilter = (): IPropsFilterModel[] => {
  return [
    {
      value: 'L1',
      label: 'L1 Casco Histórico'
    },
    {
      value: 'L2',
      label: 'L2 Centro- Hospital Torrecárdenas'
    },
    {
      value: 'L3',
      label: 'L3 Torrecárdenas - Nueva Almería'
    },
    {
      value: 'L4',
      label: 'L4 Torrecárdenas - La Goleta - Universidad'
    },
    {
      value: 'L5',
      label: 'L5 Centro- Villa Blanca - C.C. Torrecárdenas'
    },
    {
      value: 'L6',
      label: 'L6 El Puche - Pescadería'
    },
    {
      value: 'L7',
      label: 'L7 Piedras Redondas - Árbol de la Seda'
    },
    {
      value: 'L8',
      label: 'L8 Los Molinos - C.C. Torrecárdenas'
    },
    {
      value: 'L11',
      label: 'L11 Zapillo - Universidad - Nueva Andalucía'
    },
    {
      value: 'L12',
      label: 'L12 Nueva Andalucía - Universidad - Zapillo'
    },
    {
      value: 'L15',
      label: 'L15 Circular Levante'
    },
    {
      value: 'L18',
      label: 'L18 Torrecárdenas - Costacabana'
    },
    {
      value: 'L19',
      label: 'L19 Gregorio Marañón “La Salle” - Universidad'
    },
    {
      value: 'L20',
      label: 'L20 Centro - Hospital El Toyo'
    },
    {
      value: 'L30',
      label: 'L30 Almería - Aeropuerto - Retamar'
    },
  ]
};

// Paradas
export const getStopsFilter = (): IPropsFilterModel[] => {
  const stops: IPropsFilterModel[] = [];
  for (let i = 1; i <= 50; i++) {
    const stop: IPropsFilterModel = {
      value: i.toString(),
      label: `Parada ${i}`,
    };
    stops.push(stop);
  }
  return stops;
};
